<template>
  <div class="container">
    <div class="title">{{ $t('asset').flashcash }}</div>
    <div class="info">
      <!-- 币种选择 -->
      <div class="accoountInfo">
        <div class="left">
          <!-- From -->
          <van-popover v-model="showPopover_from" placement="bottom" :actions="allActions" @select="onSelect_from">
            <template #reference>
              <div class="item" @click="showPopover_from = !showPopover_from">
                <span> {{ $t('asset').From }}</span>
                <img class="img" :src="getCoinImg(activeFrom)" />
                <div class="name">{{ activeFrom }}</div>
                <van-icon name="arrow-down" size="13" color="var(--ntext_color)" />
              </div>
            </template>
          </van-popover>
          <div class="line"></div>
          <!-- To -->
          <van-popover v-model="showPopover_to" placement="bottom" :actions="allActions" @select="onSelect_to">
            <template #reference>
              <div class="item" @click="showPopover_to = !showPopover_to">
                <span>{{ $t('asset').To }}</span>
                <img class="img" :src="getCoinImg(activeTo)" />
                <div class="name">{{ activeTo }}</div>
                <van-icon name="arrow-down" size="13" color="var(--ntext_color)" />
              </div>
            </template>
          </van-popover>
        </div>
        <svg-icon class-name="svgs" icon-class="transfer" @click="changeAccount" />
      </div>
      <!-- 账户 -->
      <div class="tit">{{ $t('auth').AccountType }}</div>
      <PopoverSelect :items="assetTypeArr" :onSelect="onSelectAssetType">
        <template #reference>
          <div class="accountInfoss">{{ assetType == 3 ? $t('asset').Spotaccount : $t('asset').Walletaccount }}
            <span> <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
          </div>
        </template>
      </PopoverSelect>
      <!-- 数量 -->
      <div class="tit">{{ $t('asset').quantity }}</div>
      <div class="numInfo">
        <van-field v-model="Amount" :placeholder="$t('recharge').amountMsg" @input="onInputNum">
          <template #right-icon>
            <span style="color: var(--ntext_color)">{{ activeFrom }}</span>
          </template>
        </van-field>
      </div>
      <!-- 选择百分比 -->
      <div class="sliderPrecent">
        <vue-slider v-model="activePrecent" @drag-start="onDragStart" @drag-end="onDragEnd" @change="handlePrecent" :min="0" :max="100" :interval="1" :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }" :dot-size="15" :tooltip="'hover'"
          :rail-style="{ backgroundColor: 'var(--info_color)', height: '5px' }" :process-style="{ backgroundColor: 'var(--text_color)' }" :dot-style="{ backgroundColor: 'var(--background_color)', border: '2px solid var(--text_color)' }"
          :tooltip-style="{ backgroundColor: 'var(--info_color)', color: 'var(--text_color)', padding: '4px 8px', borderRadius: '4px' }" />
      </div>
      <div class="lables">{{ $t('asset').availablebalance }}<span>{{ AssetBalance }} {{ activeFrom }}</span></div>
      <div class="pricess">1 {{ activeFrom }} ≈ {{ newPrice }} {{ activeTo }}</div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('public').confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import productApi from '@/api/product'
import PopoverSelect from '@/components/popoverSelect.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
  components: {
    PopoverSelect,
    VueSlider
  },
  data() {
    return {
      baseUrl: window.baseURL,
      allActions: [
        { text: 'USDT', symbol: 'HBethusdt' },
        { text: 'ETH', symbol: 'HBethusdt' },
        { text: 'BTC', symbol: 'HBbtcusdt' },
        { text: 'SOL', symbol: 'HBsolusdt' },
        { text: 'TON', symbol: 'HBtonusdt' },
        { text: 'USDC', symbol: 'HBusdcusdt' },
        { text: 'BNB', symbol: 'HBbnbusdt' },
        { text: 'XRP', symbol: 'HBxrpusdt' },
        { text: 'DAI', symbol: 'HBdaiusdt' },
        { text: 'PYUSD', symbol: 'HBpyusdusdt' },
      ],
      assetType: 4,
      showassetType: false,
      assetTypeArr: [
        { text: this.$t('asset').Walletaccount, val: 4 },
        { text: this.$t('asset').Spotaccount, val: 3 },
      ],
      newPrice: 0,
      showPopover_from: false,
      showPopover_to: false,
      activeFrom: 'ETH',
      activeTo: 'USDT',
      dragging: false,
      activePrecent: 0,
      Amount: '',
      AssetBalance: 0
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    if (this.$route.query.t) {
      this.assetType = this.$route.query.t
    }
    if (this.assetType == 3) {
      this.getProductList()
    } else {
      if (this.$route.query.b) {
        this.activeFrom = this.$route.query.b
        if (this.activeFrom === this.activeTo) {
          this.activeTo = this.allActions.find(a => a.text !== this.activeFrom).text
        }
      }
      this.getAssetBalance()
    }
  },
  methods: {
    getCoinImg(coin) {
      if (coin === 'USDT') return require('@/assets/img/USDT.png')
      if (this.assetType == 3) {
        const a = this.allActions.find(x => x.text === coin)
        return a ? a.logoUrl : ''
      }
      try { return require(`@/assets/img/${coin}.png`) } catch { return '' }
    },
    onDragStart() { this.dragging = true },
    onDragEnd() { this.dragging = false },
    async onSelectAssetType(action) {
      this.assetType = action.val
      this.showassetType = false
      if (this.assetType == 3) {
        this.getProductList()
        return
      } else {
        this.allActions = [
          { text: 'USDT', symbol: 'HBethusdt' },
          { text: 'ETH', symbol: 'HBethusdt' },
          { text: 'BTC', symbol: 'HBbtcusdt' },
          { text: 'SOL', symbol: 'HBsolusdt' },
          { text: 'TON', symbol: 'HBtonusdt' },
          { text: 'USDC', symbol: 'HBusdcusdt' },
          { text: 'BNB', symbol: 'HBbnbusdt' },
          { text: 'XRP', symbol: 'HBxrpusdt' },
          { text: 'DAI', symbol: 'HBdaiusdt' },
          { text: 'PYUSD', symbol: 'HBpyusdusdt' },
        ]
      }
      this.activeFrom = this.allActions[0].text
      this.activeTo = 'USDT'
      if (this.activeFrom === this.activeTo) {
        this.activeTo = this.allActions.find(a => a.text !== this.activeFrom).text
      }
      this.getAssetBalance()
    },
    async getProductList() {
      const res = await productApi.getProductList({ pageNum: 1, pageSize: 1000, productBusiness: 3 })
      this.allActions = res.rows.map(item => ({
        text: item.name.split('/')[0],
        symbol: item.symbol,
        logoUrl: this.baseUrl + item.logoUrl
      }))
      this.allActions.unshift({ text: 'USDT', symbol: 'HBethusdt' })
      if (!this.$route.query.b) {
        this.activeFrom = this.allActions[0].text
        this.activeTo = 'USDT'
      }
      if (this.$route.query.b) {
        this.activeFrom = this.$route.query.b
        this.activeTo = 'USDT'
      }
      if (this.activeFrom === this.activeTo) {
        this.activeTo = this.allActions.find(a => a.text !== this.activeFrom).text
      }
      this.getAssetBalance()
    },
    async onSelect_from(action) {
      this.activeFrom = action.text
      this.showPopover_from = false
      if (this.activeFrom === this.activeTo) {
        this.activeTo = this.allActions.find(a => a.text !== this.activeFrom).text
      }
      this.Amount = ''
      this.activePrecent = 0
      this.getAssetBalance()
    },
    async onSelect_to(action) {
      this.activeTo = action.text
      this.showPopover_to = false
      if (this.activeFrom === this.activeTo) {
        this.activeFrom = this.allActions.find(a => a.text !== this.activeTo).text
        this.Amount = ''
        this.activePrecent = 0
        this.getAssetBalance()
        return
      }
      this.updateRate()
    },
    async changeAccount() {
      const temp = this.activeTo
      this.activeTo = this.activeFrom
      this.activeFrom = temp
      this.Amount = ''
      this.activePrecent = 0
      this.getAssetBalance()
    },
    handlePrecent(val) {
      if (!this.dragging) {
        const snapPoints = [0, 25, 50, 75, 100]
        const closest = snapPoints.reduce((a, b) => Math.abs(b - val) < Math.abs(a - val) ? b : a)
        this.activePrecent = closest
      }
      this.Amount = ((this.activePrecent / 100) * this.AssetBalance).toFixed(6).replace(/\.?0+$/, '')
    },
    onInputNum() {
      this.activePrecent = Number(this.Amount / this.AssetBalance * 100)
      if (this.activePrecent > 100) this.activePrecent = 100
      if (this.Amount > this.AssetBalance)
        this.$toast(this.$t('asset').Insufficientavailablebalance)
    },
    async getAssetBalance() {
      const res = await userApi.getAssetBalance({ assetType: this.assetType, currency: this.activeFrom })
      this.AssetBalance = res.assetWallet.amount
      this.updateRate()
    },
    async updateRate() {
      try {
        if (this.activeFrom === this.activeTo) { this.newPrice = 1; return }
        let fromPrice = 1, toPrice = 1
        if (this.activeFrom !== 'USDT') {
          const a = this.allActions.find(x => x.text === this.activeFrom)
          if (a) { const r = await userApi.getCurrencyNewPrice({ symbol: a.symbol }); fromPrice = r.data }
        }
        if (this.activeTo !== 'USDT') {
          const a = this.allActions.find(x => x.text === this.activeTo)
          if (a) { const r = await userApi.getCurrencyNewPrice({ symbol: a.symbol }); toPrice = r.data }
        }
        this.newPrice = (fromPrice / toPrice).toFixed(6).replace(/\.?0+$/, '')
      } catch { this.newPrice = 0 }
    },
    async handleSub() {
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      if (this.Amount > this.AssetBalance) {
        this.$toast(this.$t('asset').Insufficientavailablebalance)
        return false
      }
      const fromAction = this.allActions.find(a => a.text === this.activeFrom)
      const toAction = this.allActions.find(a => a.text === this.activeTo)
      const form = {
        assetType: this.assetType,
        fromCurrency: this.activeFrom,
        toCurrency: this.activeTo,
        fromSymbol: fromAction ? fromAction.symbol : '',
        toSymbol: toAction ? toAction.symbol : '',
        amount: this.Amount,
      }
      await userApi.flashcash(form)
      this.$toast(this.$t('asset').flashcashsuccessful)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 0 auto;
    max-width: 480px;
  }

  .accountInfoss {
    margin: 10px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    padding: 15px;
    font-size: 16px;
    font-weight: bold;
    color: var(--text_color);
    &:hover {
      border: 1px solid var(--primary_color);
    }
  }

  .accoountInfo {
    margin: 20px 0;
    padding: 15px;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 100%;

      .item {
        display: flex;
        align-items: center;

        span {
          color: var(--ntext_color);
          font-size: 13px;
        }

        .img {
          margin-left: 20px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .name {
          margin: 0 5px;
          font-size: 16px;
          font-weight: bold;
          color: var(--text_color);
        }
      }

      .line {
        margin: 15px 0;
        border-bottom: 1px dashed var(--info_color);
      }
    }

    .svgs {
      margin-left: 15px;
      width: 27px;
      height: 27px;
      color: var(--primary_color);
      &:hover { opacity: 0.8; }
    }
  }

  .tit {
    margin-top: 10px;
    font-size: 13px;
    color: var(--text_color);
  }

  .ric { transform: rotate(90deg); }

  .numInfo { margin-top: 10px; }

  .sliderPrecent {
    margin: 20px 5px;
    .slable {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: var(--ntext_color);
    }
  }

  .lables {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: right;
    font-size: 13px;
    color: var(--ntext_color);
    span { margin-left: 10px; color: var(--text_color); font-weight: bold; }
  }

  .pricess {
    margin-top: 70px;
    font-size: 13px;
    text-align: center;
    color: var(--ntext_color);
  }

  .van-button {
    margin: 10px 0;
    background: var(--primary_color);
    height: 40px;
    border-radius: 20px;
    border: 0;
    font-size: 15px;
    color: #fff;
    &:hover { opacity: 0.8; }
  }
}

::v-deep .van-field__value { overflow: visible; display: grid; }

.van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .van-field__control { color: var(--text_color); }
::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
::v-deep .vue-slider-dot-tooltip-inner-top::after { border-top-color: var(--info_color) !important; }
::v-deep .vue-slider-mark {
  background: var(--background_color);
  width: 10px !important;
  height: 10px !important;
  border: 2px solid var(--info_color);
  border-radius: 50%;
}
::v-deep .vue-slider-mark-active { border: 2px solid var(--text_color); }
::v-deep .vue-slider-mark-label { color: var(--ntext_color); font-size: 11px; }
</style>
